import "./App.css";
import * as React from "react";
import VisitorDashboard from "./components/dashboard/visitor/VisitorDashboard";
import ExhibitorDashboard from "./components/dashboard/exhibitor/ExhibitorDashboard";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-circular-progressbar/dist/styles.css";
import ExhibitorFloorPlan from "./components/floorplan/made/ExhibitorFloorPlan";
import { QueryClient, QueryClientProvider } from "react-query";
import "react-quill/dist/quill.snow.css";
import HallView from "./components/floorplan/view/HallView";
import MeetingDetail from "./components/dashboard/exhibitor/meeting/MeetingDetail";
import HomePage from "./home/HomePage";
import Dashboard from "./home/dashboard";
import { ThemeProvider } from "@mui/material";
import { ExpoTheme } from "./theme/theme";
import ScheduleMeeting from "./components/dashboard/exhibitor/meeting/ScheduleMeeting";
import MobileHallView from "./components/floorplan/view/MobileHallView";
import { ViewBadgeMobile } from "./components/dashboard/visitor/ViewBadgeMobile";
import ExhibitorExplore from "./components/dashboard/exhibitor/explore/Explore";
import { MobileProvider } from "./components/context/MobileContext";
import SetPasswordActivationPage from "./visitorregt/pages/PasswordSet";
import TestKonva from "./TestKonva";
import CreateAccount from "./components/dashboard/visitor/CreateAccount";
import RegisrationQr from "./visitorregt/pages/RegisrationQr";
import DocumentMeta from "./DocumentMeta";
import VisitorCardView from "./widgets/VisitorCardView";
import EventLogin from "./components/login/EventLogin";
import VisitorLogin from "./components/login/VisitorLogin";
import ScanService from "./components/onsite/ScanService";
import ViewBadge from "./pages/ViewBadge";
const queryClient = new QueryClient();
function App() {
  return (
    <ThemeProvider theme={ExpoTheme}>
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <BrowserRouter>
            <DocumentMeta />
            <ToastContainer autoClose={1500} />
            <Routes>
              <Route exact path="/" element={<HomePage />} />
              <Route exact path="/home" element={<Dashboard />} />
              <Route path="/service-scan" element={<ScanService />} />
              <Route path="/view-my-badge" element={<ViewBadgeMobile />} />
              <Route path="/view-badge/:barcodeId" element={<ViewBadge />} />
              <Route
                path="/mobile-hall-view/:id"
                element={<MobileHallView />}
              />
              <Route
                exact
                path="/visitor-card-view/:id"
                element={<VisitorCardView />}
              />
              <Route path="/reg-qr/:linkCode" element={<RegisrationQr />} />
              <Route
                exact
                path="/explore/exhibitor/*"
                element={
                  <MobileProvider>
                    <ExhibitorExplore />
                  </MobileProvider>
                }
              />
              <Route
                exact
                path="/create-team-account/:id"
                element={<CreateAccount />}
              />
              <Route exact path="/login" element={<EventLogin />} />
              <Route exact path="/visitor-login" element={<VisitorLogin />} />

              <Route path="/meeting-scheduler" element={<ScheduleMeeting />} />

              <Route path="/hall-view/:id" element={<HallView />} />

              <Route
                path="/exhibitor-floor-plan"
                element={<ExhibitorFloorPlan />}
              />
              <Route
                exact
                path="/activation-link/:code"
                element={<SetPasswordActivationPage />}
              />
              <Route exact path="/test-konva" element={<TestKonva />} />
              <Route path="/visitor/*" element={<VisitorDashboard />} />
              <Route path="/trade_delegate/*" element={<VisitorDashboard />} />
              <Route path="/team/*" element={<VisitorDashboard />} />
              <Route exact path="/meeting/:id" element={<MeetingDetail />} />

              <Route
                path="/exhibitor/*"
                element={
                  <MobileProvider>
                    <ExhibitorDashboard />
                  </MobileProvider>
                }
              />
            </Routes>
          </BrowserRouter>
        </div>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
